import { render, staticRenderFns } from "./mainPicture.vue?vue&type=template&id=fd7a7b6a&scoped=true&"
import script from "./mainPicture.vue?vue&type=script&lang=ts&"
export * from "./mainPicture.vue?vue&type=script&lang=ts&"
import style0 from "./mainPicture.vue?vue&type=style&index=0&id=fd7a7b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7a7b6a",
  null
  
)

export default component.exports